var __defProp = Object.defineProperty;

export {
  __defProp
};
